export default "__VITE_ASSET__gGd2AfpS__"